// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0a95fb4a","455":"b0715b72"}[chunkId] + ".chunk.js";
};